// Resolve an app-internal media path (e.g. a profile-photo URL stored in
// users.image) to something an <img src> can load.
//
// Lives in its own module (not api.ts) so low-level UI primitives like
// the shared Avatar can use it without importing the API client — that
// would risk a circular dependency. api.ts re-exports it for callers
// that already import from there.
//
// In same-origin deploys this is a no-op; in cross-origin dev
// (VITE_API_ORIGIN set) it prefixes the API origin so the browser
// fetches the bytes from the Worker, not the Vite dev server. Absolute
// URLs + data:/blob: URIs pass through unchanged.

const API_ORIGIN = import.meta.env["VITE_API_ORIGIN"] ?? "";

export function resolveMediaUrl(path: string | null | undefined): string | null {
  if (!path) return null;
  if (/^(https?:|data:|blob:)/.test(path)) return path;
  return API_ORIGIN ? `${API_ORIGIN}${path}` : path;
}
